import { useTranslation } from 'react-i18next';
import Button from 'components/Button/Button';
import EmptyTaskManagement from 'components/EmptyTaskManagement/EmptyTaskManagement';
import Loader from 'components/Loader/Loader';
import Panel from 'components/Panel/Panel';
import { USER_PILLAR_ACCESS_TYPES, USERS_ROLE } from 'constants/interfaces';

import CreateTaskModal from './components/CreateTaskModal';
import TaskFilters from './components/TaskFilters';
import TaskListBoard from './components/TaskListBoard';

import type ITaskManagementView from './interfaces/ITaskManagementView';

import styles from './sass/TaskManagement.module.scss';

function TaskManagementView({
  isEmptyList, onCloseModal, activeModal, onOpenModal, control, onSearchChange, taskList,
  loading, onReadMoreClients, hasNext, onSortChange, valueChainMapList, userData,
  onDownloadFile, materialityAssessmentList,
}: ITaskManagementView) {
  const { t } = useTranslation();
  const canCreateTask = userData.role === USERS_ROLE.admin || userData.role === USERS_ROLE.companyAdmin;
  const canChangeStatus = userData.permissionTaskManagement === USER_PILLAR_ACCESS_TYPES.viewEdit;

  return (
    <div className={styles.root}>
      <div className={styles.header}>
        <p>{t('taskManagement.title')}</p>
        {isEmptyList ? null : (
          <Button
            title={t('taskManagement.buttonTitle')}
            onClick={onOpenModal}
            disabled={!canCreateTask}
          />
        )}
      </div>
      <TaskFilters
        control={control}
        onSearchChange={onSearchChange}
        valueChainList={valueChainMapList}
        onDownloadFile={onDownloadFile}
        materialityAssessmentList={materialityAssessmentList}
      />
      {loading ? (
        <Panel className={styles.panel}>
          <Loader isPageLoading />
        </Panel>
      ) : null}
      {isEmptyList && !loading ? (
        <Panel className={styles.panel}>
          <EmptyTaskManagement
            title={t('taskManagement.subTitle')}
            buttonTitle={t('taskManagement.buttonTitle')}
            buttonOnClick={onOpenModal}
            disabledButton={!canCreateTask}
          />
        </Panel>
      ) : null}
      {!isEmptyList && !loading ? (
        <TaskListBoard
          control={control}
          taskList={taskList}
          onReadMoreClients={onReadMoreClients}
          hasNext={hasNext}
          onSortChange={onSortChange}
          isLoading={loading}
          canChangeStatus={canChangeStatus}
        />
      ) : null}

      <CreateTaskModal
        open={activeModal}
        onClose={onCloseModal}
      />
    </div>
  );
}

export default TaskManagementView;
